<div class="bar-chart-container">
  <canvas id="{{ chartId }}"></canvas>
</div>
